// <s-leaf-toggle> — header button that turns the falling-leaves overlay on/off. Stores the choice in
// localStorage ("simevra-leaves" = "off") and mirrors it on <html data-leaves="off">, which the
// falling-leaves block hides via CSS. The inline head script in layout/theme.liquid applies the stored
// choice before paint. One component per file.
class SLeafToggle extends HTMLElement {
  #button = null;

  connectedCallback() {
    this.#button = this.querySelector("button");
    if (!this.#button) return;
    this.#sync();
    this.#button.addEventListener("click", this.#onClick);
  }

  disconnectedCallback() {
    this.#button?.removeEventListener("click", this.#onClick);
  }

  #onClick = () => {
    const off = document.documentElement.dataset.leaves !== "off";
    if (off) document.documentElement.dataset.leaves = "off";
    else delete document.documentElement.dataset.leaves;
    try {
      if (off) localStorage.setItem("simevra-leaves", "off");
      else localStorage.removeItem("simevra-leaves");
    } catch (_) {
      // Storage can be unavailable (private mode); the toggle still works for this page view.
    }
    this.#sync();
  };

  #sync() {
    const on = document.documentElement.dataset.leaves !== "off";
    this.#button.setAttribute("aria-pressed", String(on));
  }
}

if (!customElements.get("s-leaf-toggle")) {
  customElements.define("s-leaf-toggle", SLeafToggle);
}
